import { render, staticRenderFns } from "./roleauthorityset.vue?vue&type=template&id=039b82c2&scoped=true&"
import script from "./roleauthorityset.vue?vue&type=script&lang=js&"
export * from "./roleauthorityset.vue?vue&type=script&lang=js&"
import style0 from "./roleauthorityset.vue?vue&type=style&index=0&id=039b82c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039b82c2",
  null
  
)

export default component.exports